import React from 'react'
import PropTypes from 'prop-types'

interface AppAvatarProps {
    title?: string
    titleTooltip?: string
    descriptionTooltip?: string
    activeTooltipTitle?: boolean
    activeTooltipDescription?: boolean
    description?: string | React.ReactNode
    image?: string | React.ReactNode
}

const AppAvatar: React.FC<AppAvatarProps> = ({
    title,
    activeTooltipTitle = false,
    description,
    activeTooltipDescription = false,
    image = '',
}) => {
    return (
        <div className="flex gap-2 items-center">
            {image !== '' && image !== null ? (
                typeof image === 'string' && image.length === 2 ? (
                    <div className="w-8 h-8 rounded-full bg-[#F1F5F9] flex items-center justify-center">
                        <h2
                            aria-label="Text-Diminutive"
                            className="text-[#475569] font-semibold"
                        >
                            {image}
                        </h2>
                    </div>
                ) : typeof image === 'string' ? (
                    <img
                        aria-label="ImageSelected"
                        src={image}
                        alt="ImageSelected"
                        className="w-8 h-8 rounded-full"
                    />
                ) : (
                    image
                )
            ) : null}
            <div className="flex flex-col gap-1">
                {title && (
                    <>
                        {activeTooltipTitle ? (
                            <></>
                        ) : (
                            <h1 className="font-semibold text-md">{title}</h1>
                        )}
                    </>
                )}

                {description && (
                    <>
                        {activeTooltipDescription ? (
                            <></>
                        ) : (
                            <h2 className="text-xs font-medium text-[#475569]">
                                {description}
                            </h2>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

AppAvatar.propTypes = {
    title: PropTypes.string,
    titleTooltip: PropTypes.string,
    descriptionTooltip: PropTypes.string,
    activeTooltipTitle: PropTypes.bool,
    activeTooltipDescription: PropTypes.bool,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default AppAvatar
